module.exports = __webpack_public_path__ + "img/aParty_110923_F.ca39dcc1.jpg";